import MsSafeDisplay from './src/index.vue'

export default MsSafeDisplay
